import React from 'react';

import { About, Seo, SeoHidden } from 'components';

export default () => (
  <>
    <Seo
      title="Услуги"
      description="Услуги диджитал-агентства Nimax: стратегия и диджитал. Помогаем стартовать и меняться. Объединяем отраслевой опыт клиента и нашу диджитал-экспертизу."
      robots="noindex, follow"
    />
    <SeoHidden>
      <h1>Услуги</h1>
    </SeoHidden>
    <About />
  </>
);
